import {
  SET_LOADER_START,
  SET_LOADER_COMPLETE,
  SET_CATEGORY_LOADER_START,
  SET_CATEGORY_LOADER_COMPLETE
} from '../constants';

export default function loader(state = {}, action) {
  switch (action.type) {
    case SET_LOADER_START:
      return {
        ...state,
        [action.payload.name]: action.payload.status,
      };

    case SET_LOADER_COMPLETE:
      return {
        ...state,
        [action.payload.name]: action.payload.status,
      };

    case SET_CATEGORY_LOADER_START: {
      const { name, id } = action.payload;
      return {
        ...state,
        [name]: {
          ...state[name],
          [id]: true
        }
      };
    }

    case SET_CATEGORY_LOADER_COMPLETE: {
      const { name, id } = action.payload;
      const updated = { ...state[name] };
      delete updated[id];
      return {
        ...state,
        [name]: updated
      };
    }


    default:
      return state;
  }
}